import { gql } from "@apollo/client";

export const UPDATE_INVITE_LINK_SIZE = gql`
    mutation UpdateInviteLinkSize($id: String!, $size: UserSize!) {
        updateInviteLinkSize(id: $id, size: $size) {
            id
            email
            role
            size
            isUsed
            createdAt
        }
    }
`; 